/*
 * Copyright Higharc Inc. 2019
 */
import { Color, NearestFilter, RGBAFormat } from "three";
import { TetrahedronCamera } from "./TetrahedronCamera";

let tetraCamera: any = undefined;
let tetraCameraNear = 0;
let tetraCameraFar = 0;
let tetraCameraResolution = 0;
const originalClearColor = new Color();
let tetraCameraColorSpace: any = undefined;
let tetraCameraFramebufferDataType: any = undefined;

function render(
  renderer,
  scene,
  positionObj,
  near,
  far,
  cameraResolution,
  colorSpace,
  framebufferDataType,
  clearColor,
  clearAlpha,
  layers,
) {
  near = near !== undefined ? near : 0.1;
  far = far !== undefined ? far : 10.0;
  cameraResolution = cameraResolution !== undefined ? cameraResolution : 64;
  if (
    tetraCamera === undefined ||
    tetraCameraNear !== near ||
    tetraCameraFar !== far ||
    tetraCameraResolution !== cameraResolution ||
    tetraCameraColorSpace !== colorSpace ||
    tetraCameraFramebufferDataType !== framebufferDataType
  ) {
    if (tetraCamera !== undefined) {
      tetraCamera.dispose();
    }
    tetraCamera = new TetrahedronCamera(near, far, cameraResolution, {
      format: RGBAFormat,
      type: framebufferDataType,
      magFilter: NearestFilter,
      minFilter: NearestFilter,
      stencilBuffer: false,
      colorSpace,
    });
    tetraCameraNear = near;
    tetraCameraFar = far;
    tetraCameraResolution = cameraResolution;
    tetraCameraColorSpace = colorSpace;
    tetraCameraFramebufferDataType = framebufferDataType;
  }
  tetraCamera.traverse(function (obj) {
    if (layers !== undefined) {
      obj.layers.mask = layers.mask;
    } else {
      obj.layers.enableAll();
    }
  });
  scene.add(tetraCamera);
  positionObj.getWorldPosition(tetraCamera.position);
  positionObj.getWorldQuaternion(tetraCamera.quaternion);
  tetraCamera.updateMatrixWorld();

  renderer.getClearColor(originalClearColor);
  const originalClearAlpha = renderer.getClearAlpha();

  renderer.setClearColor(clearColor, clearAlpha);
  tetraCamera.update(renderer, scene, true, true, false);

  renderer.setClearColor(originalClearColor);
  renderer.setClearAlpha(originalClearAlpha);

  scene.remove(tetraCamera);
}

export const TetrahedronCameraUtil: any = {
  renderCubeMap: function (
    renderer,
    scene,
    positionObj,
    near,
    far,
    cameraResolution,
    cubeResolution,
    colorSpace,
    framebufferDataType,
    clearColor,
    clearAlpha,
    processCubeFaceBuffer,
    layers,
  ) {
    render(
      renderer,
      scene,
      positionObj,
      near,
      far,
      cameraResolution,
      colorSpace,
      framebufferDataType,
      clearColor,
      clearAlpha,
      layers,
    );
    cubeResolution = cubeResolution !== undefined ? cubeResolution : 32;
    return tetraCamera.readAsCubeMap(renderer, cubeResolution, processCubeFaceBuffer);
  },

  renderTetrahedronMap: function (
    renderer,
    scene,
    positionObj,
    near,
    far,
    cameraResolution,
    colorSpace,
    framebufferDataType,
    clearColor,
    clearAlpha,
    processFaceBuffer,
    layers,
  ) {
    render(
      renderer,
      scene,
      positionObj,
      near,
      far,
      cameraResolution,
      colorSpace,
      framebufferDataType !== undefined ? framebufferDataType : tetraCameraFramebufferDataType,
      clearColor,
      clearAlpha,
      layers,
    );
    return tetraCamera.readAsTetrahedronMap(renderer, processFaceBuffer);
  },
};
